import { makeStyles } from '@fluentui/react-components';
export var useFlyoutButtonBadgeStyles = makeStyles({
    flyoutButtonBadgeWide: {
        left: '36px',
    },
    flyoutButtonBadge: {
        display: 'block',
    },
});
//# sourceMappingURL=FlyoutButtonBadge.styles.js.map